module.exports = {
  "purple1" : "#855279", "purple2" : "#BD75AC", "purple3" : "#DBC0D4",
  "yellow1" : "#AC8E4C", "yellow2" : "#F4C96C", "yellow3" : "#F0DFBC",
  "peach1" : "#AE6E52", "peach2" : "#F79C75", "peach3" : "#F1CEBF",
  "blue1" : "#1B6383", "blue2" : "#268CBA", "blue3" : "#A1C8DA",
  "teal1" : "#127479", "teal2" : "#19A4AB", "teal3" : "#9CD1D4",
  "gray1" : "#393939", "gray2" : "#828282", "gray3" : "#DCDCDC", "gray4" : "#ECECEC"
};
